export var getBasketIdFromUrl = function () {
    var url = location.search;
    var regex = /\/?\?basketid=([a-zA-Z0-9]+)/i;
    var match = url.match(regex);
    return match ? match[1] : null;
};
